var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nr_container_content mt-60 " },
    [
      _c("v-modal-contents", {
        ref: "modal_contents_successfully",
        staticClass: "modal_contents_successfully ",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("span")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title" }, [
                  _c("div", { staticClass: "h2_title h2_title--modal" }, [
                    _vm._v("Ваши ответы приняты"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use" }, [
                  _c("p", { staticClass: "green_messs" }, [
                    _vm._v("Благодарим вас за уделенное время"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "mt-4 btn v-btn btn_poll",
                      attrs: { href: "/" },
                    },
                    [_vm._v("Хорошо")]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-modal-contents", {
        ref: "modal_alert",
        staticClass: "modal_alert ",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title " }, [
                  _c("div", { staticClass: "h2_title h2_title--modal" }, [
                    _vm._v("Уведомление"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use " }, [
                  _c("p", { staticClass: "green_messs" }, [
                    _vm._v("Пожалуйста, ответьте на все вопросы"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "poll",
          class: _vm.validAll ? "valid" : "noValid",
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("v-text-field", {
            staticClass: "mb-20",
            attrs: {
              label: "1. Название Вашей компании",
              rules: _vm.rulesField,
              required: "",
            },
            model: {
              value: _vm.companyName,
              callback: function ($$v) {
                _vm.companyName = $$v
              },
              expression: "companyName",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "mb-20",
            attrs: {
              label: "2. Ваше имя и фамилия",
              rules: _vm.rulesField,
              required: "",
            },
            model: {
              value: _vm.contactPerson,
              callback: function ($$v) {
                _vm.contactPerson = $$v
              },
              expression: "contactPerson",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "mb-20",
            attrs: {
              label: "3. Электронная почта",
              rules: _vm.emailRules,
              required: "",
              type: "email",
            },
            model: {
              value: _vm.email,
              callback: function ($$v) {
                _vm.email = $$v
              },
              expression: "email",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom_label",
              class: _vm.purchasedProducts.length === 0 ? "noValidError" : "",
            },
            [
              _vm._v(
                "\n            4. Какие продукты Вы закупаете у ГК NOVAROLL?\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-35 checkbox_group" },
            [
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Упаковочные клейкие ленты",
                  value: "Упаковочные клейкие ленты",
                },
                model: {
                  value: _vm.purchasedProducts,
                  callback: function ($$v) {
                    _vm.purchasedProducts = $$v
                  },
                  expression: "purchasedProducts",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Стретч-пленка",
                  value: "Стретч-пленка",
                },
                model: {
                  value: _vm.purchasedProducts,
                  callback: function ($$v) {
                    _vm.purchasedProducts = $$v
                  },
                  expression: "purchasedProducts",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "5. Насколько качество продукции ГК NOVAROLL соответствует Вашим ожиданиям? (от 1 до 10, где 1 – качество продукции низкое, 10 – качество продукции полностью соответствует ожиданиям)",
              },
              model: {
                value: _vm.productQuality,
                callback: function ($$v) {
                  _vm.productQuality = $$v
                },
                expression: "productQuality",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "quality-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "6. С какой вероятностью вы разместите следующий заказ? (от 1 до 10, где 1 – пока не стану размещать заказ, 10 – следующий заказ только в ГК NOVAROLL)",
              },
              model: {
                value: _vm.nextOrderProbability,
                callback: function ($$v) {
                  _vm.nextOrderProbability = $$v
                },
                expression: "nextOrderProbability",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "next-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "7. Оцените, насколько вы в целом удовлетворены взаимодействием с ГК NOVAROLL? (от 1 до 10, где 1 – не удовлетворён, 10 – полностью удовлетворен)",
              },
              model: {
                value: _vm.satisfactionLevel,
                callback: function ($$v) {
                  _vm.satisfactionLevel = $$v
                },
                expression: "satisfactionLevel",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "satisf-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesField,
                required: "",
                label:
                  "8. Оцените, насколько вероятно, что вы порекомендуете ГК NOVAROLL своим коллегам или партнерам? (от 1 до 10, где 1 – не буду рекомендовать, 10 – буду рекомендовать)",
              },
              model: {
                value: _vm.recommendationProbability,
                callback: function ($$v) {
                  _vm.recommendationProbability = $$v
                },
                expression: "recommendationProbability",
              },
            },
            _vm._l(10, function (n) {
              return _c("v-radio", {
                key: "rec-" + n,
                attrs: { color: "red", label: String(n), value: String(n) },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label:
                "9. Ваши предложения по улучшению нашей работы/продукции (не менее 10 знаков)",
              rules: _vm.improvementRules,
              required: "",
              rows: "1",
              "auto-grow": "",
            },
            model: {
              value: _vm.improvementSuggestions,
              callback: function ($$v) {
                _vm.improvementSuggestions = $$v
              },
              expression: "improvementSuggestions",
            },
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mt-30",
              attrs: { color: "#f94237" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submitSurvey.apply(null, arguments)
                },
              },
            },
            [_vm._v("Отправить")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }